import urlResolver from 'edrolo/utils/URLResolver';
import { get } from 'edrolo/domains/net';

export async function loadBranches(branchType, courseId) {
  const branchTypeMap = {
    subjects: 'subject',
    courses: 'course',
    topics: 'area of study',
    lessons: 'lesson',
  };
  const branchTypeForQuery = branchTypeMap[branchType];
  const url = urlResolver.reverse('api:branch-for-select');
  const response = await get(url, {
    transformRequest: (req) =>
      req.query({ type: branchTypeForQuery, course: courseId }),
  });
  if (response.ok) {
    return response.body;
  }
  throw response;
}

export async function loadCourseAssemblageByCourseId(courseId) {
  const url = urlResolver.reverse('api:course-collection', { courseId });
  return get(url);
}

export async function loadCourseBranches(url) {
  const response = await get(url, {
    transformRequest: (req) => req.query({ type: 'course' }),
  });
  if (response.ok) {
    return response.body;
  }
  throw response;
}
